/**
 * Генерирует текстовое описание условий платежей на основе переданной строки с типом платежей.
 *
 * @param typeString {string} - Строка с типом платежей.
 * @returns {string[] | string} Массив строк с текстовыми описаниями условий платежей.
 */

const getPaymentText = typeString => {
  const yearsWithoutInterest = typeString?.split('-')[0];
  if (!yearsWithoutInterest && !typeString) return '';
  const firstNum = textToNum(yearsWithoutInterest);
  if (!firstNum) return '';

  if (firstNum === 1) {
    return ['Платёж в первый год', `Платёж со ${firstNum + 1} года`];
  }
  return [
    `Платёж первые ${firstNum} ${firstNum > 1 && firstNum < 5 ? 'года' : 'лет'} `,
    `Платёж с ${firstNum + 1} года`,
  ];
};

export default getPaymentText;

/**
 * Преобразует текстовое представление числа в числовое значение.
 *
 * @param numStr {string} - Текстовое представление числа.
 * @returns {number} Числовое значение.
 */
const textToNum = numStr => {
  const numObj = {
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6,
    seven: 7,
    eight: 8,
    nine: 9,
    ten: 10,
    eleven: 11,
    twelve: 12,
  };
  return numObj[numStr];
};
